// Validação e formatação de telefone
export class PhoneValidator {
  // Remove caracteres não numéricos
  static cleanPhone(phone) {
    return phone.replace(/\D/g, '');
  }

  // Formata telefone com máscara ((00) 00000-0000)
  static formatPhone(phone) {
    const cleaned = this.cleanPhone(phone);
    if (cleaned.length === 0) return '';
    
    // Limita a 11 dígitos (DDD + 9 dígitos)
    const limited = cleaned.slice(0, 11);
    
    // Aplica máscara baseada no tamanho
    if (limited.length <= 2) return `(${limited}`;
    if (limited.length <= 6) return `(${limited.slice(0, 2)}) ${limited.slice(2)}`;
    if (limited.length <= 10) return `(${limited.slice(0, 2)}) ${limited.slice(2, 6)}-${limited.slice(6)}`;
    return `(${limited.slice(0, 2)}) ${limited.slice(2, 7)}-${limited.slice(7)}`;
  }

  // Valida se o telefone é válido
  static isValidPhone(phone) {
    const cleaned = this.cleanPhone(phone);
    
    // Deve ter pelo menos 10 dígitos (DDD + 8 dígitos) e no máximo 11 (DDD + 9 dígitos)
    if (cleaned.length < 10 || cleaned.length > 11) return false;
    
    // DDD deve ser válido (11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62, 63, 64, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 92, 93, 94, 95, 96, 97, 98, 99)
    const ddd = cleaned.slice(0, 2);
    const validDDDs = [
      '11', '12', '13', '14', '15', '16', '17', '18', '19',
      '21', '22', '24', '27', '28',
      '31', '32', '33', '34', '35', '37', '38',
      '41', '42', '43', '44', '45', '46', '47', '48', '49',
      '51', '53', '54', '55',
      '61', '62', '63', '64', '65', '66', '67', '68', '69',
      '71', '73', '74', '75', '77', '79',
      '81', '82', '83', '84', '85', '86', '87', '88', '89',
      '91', '92', '93', '94', '95', '96', '97', '98', '99'
    ];
    
    if (!validDDDs.includes(ddd)) return false;
    
    // Número não pode ser todo igual
    const number = cleaned.slice(2);
    if (/^(\d)\1{7,8}$/.test(number)) return false;
    
    return true;
  }

  // Valida telefone formatado (com máscara)
  static isValidFormattedPhone(phone) {
    // Verifica formato
    const formatRegex = /^\(\d{2}\)\s\d{4,5}-\d{4}$/;
    if (!formatRegex.test(phone)) return false;
    
    // Valida conteúdo
    return this.isValidPhone(phone);
  }

  // Retorna telefone formatado se válido, ou string vazia se inválido
  static getValidFormattedPhone(phone) {
    if (this.isValidPhone(phone)) {
      return this.formatPhone(phone);
    }
    return '';
  }

  // Validação em tempo real para inputs
  static validateInput(input) {
    const cleaned = this.cleanPhone(input);
    
    // Se vazio, permite
    if (cleaned.length === 0) return { isValid: true, message: '' };
    
    // Se menos de 10 dígitos, ainda está digitando
    if (cleaned.length < 10) return { isValid: true, message: 'Digite o telefone completo' };
    
    // Se entre 10 e 11 dígitos, valida
    if (cleaned.length >= 10 && cleaned.length <= 11) {
      if (this.isValidPhone(cleaned)) {
        return { isValid: true, message: 'Telefone válido' };
      } else {
        return { isValid: false, message: 'Telefone inválido' };
      }
    }
    
    // Se mais de 11 dígitos, inválido
    return { isValid: false, message: 'Telefone deve ter 10 ou 11 dígitos' };
  }
}

export default PhoneValidator;
























